import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const location = useLocation();

  // Hide on admin pages
  if (location.pathname.startsWith('/dashboard4')) {
    return null;
  }

  return (
    <footer className="footer footer-simple">
      <div className="container">
        <div className="footer-bottom">
          <p>web.ae | <Link to="/">home</Link></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
